import React, { useState } from "react";
import { Button, Image } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import "./style.scss";
import { BackArrow } from "../../../../Icons/BackArrow";

interface Props {
  resultsUrls: string[];
}

const ImageSlider: React.FC<Props> = ({ resultsUrls }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNext = () => {
    if (currentIndex < resultsUrls.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const goToPrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleDownload = () => {
    const imageUrl = resultsUrls[currentIndex];
    window.open(imageUrl, "_blank");
  };

  return (
    <div>
      <div className="result-header-actions">
        <p>Request Results</p>
        <div className="result-slider-actions">
          <Button
            onClick={goToPrevious}
            type="link"
            disabled={currentIndex === 0}
          >
            <BackArrow />
            Previous
          </Button>
          <Button
            onClick={goToNext}
            type="link"
            disabled={currentIndex === resultsUrls.length - 1}
          >
            Next
            <span style={{ transform: "rotate(180deg)" }}>
              <BackArrow />
            </span>
          </Button>
        </div>
        <Button
          icon={<DownloadOutlined />}
          type="primary"
          onClick={handleDownload}
        >
          Download
        </Button>
      </div>
      <div className="results-images">
        <Image
          src={resultsUrls[currentIndex]}
          alt={`Slide ${currentIndex + 1}`}
          style={{ maxHeight: 600, objectFit: "contain" }}
        />
      </div>
    </div>
  );
};

export default ImageSlider;
